function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
export default function DropdownContents(props) {
  var styleProps = {};

  if (props.minWidth) {
    styleProps.minWidth = props.minWidth;
  }

  if (props.canScroll) {
    styleProps.overflowY = 'visible';
    styleProps.maxHeight = 'none';
  }

  var classes = classNames({
    'nowrap': props.isNoWrap,
    'oui-dropdown': true,
    'oui-dropdown--right': props.direction === 'left',
    'oui-dropdown--up': props.direction === 'up'
  });
  return React.createElement("ul", _extends({
    className: classes,
    style: styleProps
  }, props.testSection ? {
    'data-test-section': props.testSection
  } : {}), props.children);
}
DropdownContents.propTypes = {
  /** Whether contents can scroll */
  canScroll: PropTypes.bool,

  /** Nodes to display within */
  children: PropTypes.node.isRequired,

  /** Direction of contents */
  direction: PropTypes.oneOf(['left', 'right', 'up']),

  /** Whether to wrap contents or not */
  isNoWrap: PropTypes.bool,

  /** Minimum width of contents */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Test section for element */
  testSection: PropTypes.string
};
DropdownContents.defaultProps = {
  canScroll: false,
  direction: 'left',
  isNoWrap: false,
  testSection: ''
};